// extracted by mini-css-extract-plugin
export default {"component":"D7-XI"};